import getExtensibilityState from '../store/getExtensibilityState';
import TaskPaneType from '../store/schema/TaskPaneType';
import { getConverseTaskPaneType, getTaskPaneRunningInstance } from '../utils/taskPaneUtils';
import { mutatorAction } from 'satcheljs';
import type TaskPaneRunningInstance from '../store/schema/TaskPaneRunningInstance';

export default mutatorAction(
    'toggleTaskPaneType',
    function toggleTaskPaneType(taskPaneType: TaskPaneType, addinId: string) {
        const { taskPanes } = getExtensibilityState();

        // toggling from pinning to unpinning
        if (taskPaneType === TaskPaneType.Persistent) {
            for (let [addinInstanceString, taskPane] of taskPanes) {
                //If there is only one add-in opened for that hostItemIndex and tabId
                if (taskPanes.get(addinInstanceString).size === 1) {
                    for (let [type, instance] of taskPane) {
                        //If the same addin isopened and is persistent, just toggle the state to unpin
                        if (
                            type === TaskPaneType.Persistent &&
                            instance.addinCommand.extension.Id === addinId
                        ) {
                            const taskPaneInstance: TaskPaneRunningInstance = getTaskPaneRunningInstance(
                                type,
                                instance.hostItemIndex,
                                instance.targetWindow
                            );
                            taskPanes.get(addinInstanceString).delete(type);
                            taskPanes
                                .get(addinInstanceString)
                                .set(getConverseTaskPaneType(taskPaneType), taskPaneInstance);
                        }
                    }
                } else {
                    /* If we have two add-ins opened for that hostItemIndex and tabId, means NonPersistent
                        add-in is covering the persistent addin, so instead of unpinning the add-in, we need
                        to delete it from the map*/
                    taskPanes.get(addinInstanceString).delete(taskPaneType);
                }
            }
        }

        // toggling from unpinning to pinning
        if (taskPaneType === TaskPaneType.NonPersistent) {
            for (let [addinInstanceString, taskPane] of taskPanes) {
                //If there is only one add-in opened for that hostItemIndex and tabId
                if (taskPanes.get(addinInstanceString).size === 1) {
                    for (let [type, instance] of taskPane) {
                        /* If we have same add-in in un-pinned state Or
                            some other add-in in pinned state, then just toggle
                            the state for the add-in */
                        if (
                            (type === TaskPaneType.NonPersistent &&
                                instance.addinCommand.extension.Id === addinId) ||
                            (type === TaskPaneType.Persistent &&
                                instance.addinCommand.extension.Id !== addinId)
                        ) {
                            const taskPaneInstance: TaskPaneRunningInstance = getTaskPaneRunningInstance(
                                type,
                                instance.hostItemIndex,
                                instance.targetWindow
                            );
                            taskPanes.get(addinInstanceString).delete(type);
                            taskPanes
                                .get(addinInstanceString)
                                .set(getConverseTaskPaneType(type), taskPaneInstance);
                        }
                    }
                } else {
                    //If there are two add-ins opened for that hostItemIndex and tabId
                    const taskPaneTypes = [TaskPaneType.Persistent, TaskPaneType.NonPersistent];
                    for (let type = 0; type < taskPaneTypes.length; type++) {
                        let taskPaneType = taskPaneTypes[type];

                        const instance = taskPane.get(taskPaneType);
                        if (
                            taskPaneType === TaskPaneType.NonPersistent &&
                            instance.addinCommand.extension.Id === addinId
                        ) {
                            const taskPaneInstance: TaskPaneRunningInstance = getTaskPaneRunningInstance(
                                taskPaneType,
                                instance.hostItemIndex,
                                instance.targetWindow
                            );
                            taskPanes.get(addinInstanceString).delete(taskPaneType);
                            taskPanes
                                .get(addinInstanceString)
                                .set(getConverseTaskPaneType(taskPaneType), taskPaneInstance);
                        } else if (
                            taskPaneType === TaskPaneType.Persistent &&
                            instance.addinCommand.extension.Id !== addinId
                        ) {
                            taskPanes.get(addinInstanceString).delete(taskPaneType);
                        }
                    }
                }
            }
        }
    }
);
